<script>
    import {
        health,
        energy,
        hygiene,
        culture,
        iq,
        loneliness,
        confidence,
        stress,
        alcoholism,
        drugs,
        smooth,
        honesty,
        optimism,
        fitness,
        money,
        time,
        date,
        home_cleanliness,
        TimeEnum,
        TimeToPrint,
        upcomingEvent,
        Item,
        energy_geq_10,
        energy_geq_20,
        modal,
        daysElapsed,
        times_stared_at_walls,
        ItemCategoryEnum,
        have_cube,
        have_burbon,
        have_rollers,
        have_camera,
        have_tv,
        media,
        journalism,
        meditation,
        welding,
        basic_cooking,
        basic_law,
        people_skills,
        public_speaking,
        police_experience,
        italian,
        french,
        have_microwave,
        have_boardgame,
        have_recordplayer,
        have_bass,
        have_usedbass,
        have_guitar,
        have_usedguitar,
        have_drums,
        have_useddrums,
        have_piano,
        have_sax,
        have_usedsax,
        have_keyboard,
        bass,
        guitar,
        drums,
        keys,
        sax,
        book_iq,
        book_hgg,
        book_wshp,
        book_shining,
        book_meditation,
        book_welding,
        book_confidence,
        book_cooking,
        book_history,
        book_speak,
        book_encyclopedia,
        book_law,
        book_italian,
        book_french,
        book_peopleskills, book_sherlock,
        progressTime, getDateAfterDays, addUpcomingEvent, currentJob, deletePastEvents, rnd
    } from './stores.js';
    import {
        construction_trainee,
        construction_worker,
        construction_worker2,
        construction_welder,
        construction_welder2,
        construction_welder3,
        construction_welder4,
        hustle_pickpocket,
        hustle_smuggler,
        hustle_burglar,
        hustle_dealer,
        hustle_pimp,
        dance_tap,
        dance_1,
        dance_2,
        dance_3, dance_4, dance_5, dance_6, dance_7, dance_teacher_1, dance_teacher_2, JobCategories
    } from './jobs.js';
    import Action_TV from "./Action_TV.svelte";
    import {get} from "svelte/store";

    export let currentJobCategory = null;
    export let home = false;

    $: items = [
        construction_trainee, construction_worker, construction_worker2, construction_welder, construction_welder2,
        construction_welder3, construction_welder4,
        hustle_pickpocket, hustle_smuggler, hustle_burglar, hustle_dealer, hustle_pimp,
        dance_tap, dance_1, dance_2, dance_3, dance_4, dance_5, dance_6, dance_7, dance_teacher_1, dance_teacher_2
    ]

    function getNextDay(day) {
        var next_day = new Date(day);
        next_day.setDate(next_day.getDate() + 1);
        return next_day;
    }

    const activateItem = (item) => {
        progressTime();
        item.effect();
    }

    const applyForPosition = (job) => {
        addUpcomingEvent({
            name: 'Job interview',
            date: getDateAfterDays(rnd(2, 3)),
            time: job.category === JobCategories.Hustle ? TimeEnum.night : TimeEnum.morning,
            job: job});
        progressTime();
        modal.set();
    }

</script>


{#if !home}
    <shop-pad>
    {#each items as item}
        {#if item.category === currentJobCategory}
            <sl-card id={$currentJob === item ? 'currentJob' : ''}>
                <columns>
                    <col-1 style="background-image: url({item.background_url});
                                  background-size: cover;
                                  filter: grayscale(100%);">

                    </col-1>
                    <col-2>
                        <strong>{item.name}</strong>
                        <br>
                        <em>{item.employer}</em>
                        <br>
                        <small>Daily wage: <sl-icon src="/img/coin.svg"></sl-icon>{item.dailyAvgSalary().toFixed(2)}</small><br>
                        <small>{item.description}</small><br>
                        {#if $currentJob === item}
                            <sl-icon slot="icon" name="check2-circle"></sl-icon>
                            <strong>This is your current job</strong>
                        {:else if $upcomingEvent.some((e) => e.job === item)}
                            <sl-icon slot="icon" name="check2-circle"></sl-icon>
                            <strong>You already applied for this position and have a scheduled interview soon.</strong>
                        {:else}
                            {#if !item.canApply()}
                                <requirements>Application requirements:<br>{item.requirements
                                    .replace(/ > /g, '>')
                                    .replace(/ < /g, '<')
                                    .replace(/,/g, '\n')}</requirements>
                            {/if}
                            <sl-button size="small" pill disabled={!item.canApply()}
                                       on:click={() => applyForPosition(item)}>
                                Apply
                            </sl-button>
                        {/if}
                    </col-2>
                </columns>
            </sl-card>
        {/if}
    {/each}
    </shop-pad>
{/if}


<style>
    #currentJob {
        --border-color: var(--sl-color-success-500);
    }
    requirements {
        white-space: pre-wrap;
        font-size: small;
        font-style: italic;
        line-height: 1em;
    }
    shop-pad {
        display: block;
        padding: 0em 0.3em 0 0.4em;
    }
    sl-card {
        width: 100%;
        margin-bottom: 1em;
    }
    sl-badge {
        position: absolute;
        right: 1em;
    }
    columns {
        display: flex;
    }
    col-1 {
        flex-grow: 1;
        flex-basis: 33%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    col-2 {
        padding-left: 1em;
        flex-grow: 2;
        flex-basis: 66%;
    }

    :root {
        --sl-input-height-medium: none;
    }
    sl-button.item {
        width: 4em;
        min-width: 4em;
        height: 4em;
        min-height: 4em;
    }
    button-img {
        height: 60px;
        width: 60px;
        display: block;
    }
    sl-button {
        float: right;
    }
</style>